export const SAVE_SEARCH_PARAMS = 'SAVE_SEARCH_PARAMS';

export function saveSearchParams(searchParams: any) {
  return {
    type: SAVE_SEARCH_PARAMS,
    payload: searchParams,
  };
}
